export default __webpack_public_path__ + "static/media/results-page-blur-large.486c8aef.png";